var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 5H1.875C1.525 5 1.25 4.725 1.25 4.375C1.25 4.025 1.525 3.75 1.875 3.75H18.125C18.475 3.75 18.75 4.025 18.75 4.375C18.75 4.725 18.475 5 18.125 5Z",
    fill: "#BA4949"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7754 4.7625L13.2254 2.9375C13.1875 2.80768 13.1086 2.69364 13.0004 2.6125C12.8922 2.53136 12.7606 2.4875 12.6254 2.4875H7.37539C7.24016 2.4875 7.10858 2.53136 7.00039 2.6125C6.89221 2.69364 6.81326 2.80768 6.77539 2.9375L6.22539 4.7625L5.02539 4.4L5.57539 2.575C5.81289 1.775 6.53789 1.2375 7.37539 1.2375H12.6254C13.4629 1.2375 14.1754 1.775 14.4254 2.575L14.9754 4.4L13.7754 4.7625Z",
    fill: "#BA4949"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4121 18.75H5.58711C4.57461 18.75 3.74961 17.95 3.71211 16.9375L3.28711 4.6L4.53711 4.5625L4.96211 16.9C4.96211 17.2375 5.24961 17.5 5.58711 17.5H14.4246C14.7621 17.5 15.0371 17.2375 15.0496 16.9L15.4746 4.5625L16.7246 4.6L16.2996 16.9375C16.2621 17.95 15.4371 18.75 14.4246 18.75H14.4121Z",
    fill: "#BA4949"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 14.525C7.775 14.525 7.5 14.25 7.5 13.9V8.9C7.5 8.55 7.775 8.275 8.125 8.275C8.475 8.275 8.75 8.55 8.75 8.9V13.9C8.75 14.25 8.475 14.525 8.125 14.525ZM11.875 14.525C11.525 14.525 11.25 14.25 11.25 13.9V8.9C11.25 8.55 11.525 8.275 11.875 8.275C12.225 8.275 12.5 8.55 12.5 8.9V13.9C12.5 14.25 12.225 14.525 11.875 14.525Z",
    fill: "#BA4949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.d646f99a79fecbbb9b76249c6c4105af.svg";
export { ForwardRef as ReactComponent };